import { render, staticRenderFns } from "./billingList.vue?vue&type=template&id=18a0b632&scoped=true"
import script from "./billingList.vue?vue&type=script&lang=js"
export * from "./billingList.vue?vue&type=script&lang=js"
import style0 from "./billingList.vue?vue&type=style&index=0&id=18a0b632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0b632",
  null
  
)

export default component.exports